import React from "react";
//import PropTypes from 'prop-types';
import MainTitle from './elements/MainTitle';
import Slider from '../elements/slider/Slider';
import { testimonialsAutoSlideInterval } from '../../config/app';

const slides = [
    {
        text: 'It\'s really easy and fun to cook up with Capsule. Lots of different sounds, great layout! Stock sounds are great out of the box but they can also easily be customized by changing the parameters within the plugin. Great product!',
        username: 'Swede 808 Mafia',
        title: 'Platinum Producer for Lil Wayne, Dj Khaled, Meek Mill, Gucci Mane, Nas',
        image: require('../../assets/images/testimonials/SWEDE-AUG-2020-68x68.webp'),
    },
    {
        text: 'superb quality virtual analog engine! Capsule may just become your go-to virtual instrument powerhouse. It’s finding its way into all of my music productions!',
        username: 'Dave Pohlich',
        title: 'Programmer for Michael Jackson, David Foster, Fleetwood Mac, the Cure',
        image: require('../../assets/images/testimonials/davepolichpromoshot7-68x68.webp'),
    },
    {
        text: 'Capsule is incredibly intuitive and easy to use. The vast library of high-quality sounds is enough to spark anyone\'s creativity - whether you\'re in a studio session, or just trying to get the juices flowing at home. Capsule is most definitely a weapon I\'ll be storing in my arsenal!',
        username: 'Fixxer',
        title: '',
        image: require('../../assets/images/testimonials/Profile-Pic-68x68.webp'),
    },
    {
        text: 'Capsule is becoming my go to synth for writing music of any genre. I love the cloud-based format and the presets are incredible. The synth is simple to use but very powerful! A great tool for any producer.',
        username: 'Erb N Dub',
        title: '',
        image: require('../../assets/images/testimonials/CcMqMbg4-68x68.webp'),
    }
];
export default class Testimonials extends React.PureComponent {
    render() {

        return (
            <div className={'testimonials'}>
                <MainTitle text={'What the pros think about capsule'}/>

                <Slider
                    autoplaySpeed={testimonialsAutoSlideInterval}
                    dots={true}
                    slides={slides.map((slide, index) => {
                            return (
                                <div className={'testimonial'} key={index}>
                                    <div className={'text'}>“{slide.text}”</div>
                                    <div className={'image'}>
                                        <img src={slide.image} alt={slide.username}/>
                                    </div>
                                    <div className={'username'}>{slide.username}</div>
                                    <div className={'title'}>{slide.title}</div>
                                </div>
                            )})}
                    isHtml={true}
                    slideIndex={1}/>
            </div>
        )
    }
}

Testimonials.propTypes = {

};
